import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';



@Component({
  selector: 'app-retailer',
  templateUrl: './retailer.component.html',
  styleUrls: ['./retailer.component.scss']
})
export class RetailerComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  isButtonDisabled:boolean
  @ViewChild("retailerMenu", { static: false }) retailerMenu: ElementRef;
  constructor(private adminViewServices:AdminViewService) {
    super();

  }

  ngOnInit(): void {
    super.ngOnInit()
       this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
  })
}

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onClickLeft() {
    this.retailerMenu.nativeElement.scrollLeft -= 40;
  }

  onClickRight() {
    this.retailerMenu.nativeElement.scrollLeft += 40;
  }


}